import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import { i18n } from '@international/mastodon-i18n';
import { M } from '@dashboard-experience/mastodon';
import Panel from '../../Panels';
import DownloadPDFDocuments from './DownloadPDFDocuments';
import DrugScreeningAppointment from './Screenings/DrugScreeningAppointment';
import HealthScreeningInformation from './Screenings/HealthScreeningInformation';
import { includesAppointment, onlySSN } from '../../../lib/helpers';
import CandidateProfileSelector from './CandidateProfiles/CandidateProfileSelector';
import candidateFacingStatus from './candidateFacingStatus';
import { getStatusTypeAndReportLevelStatuses } from './utils';

const getDonorPass = documents =>
  documents.find(d => d.type === 'drug_screening_donor_pass');
const Information = ({
  canada,
  pdf,
  report,
  account,
  international,
  candidateFacingStatusEnabled,
}) => {
  const { statusType, status, secondaryStatus } =
    getStatusTypeAndReportLevelStatuses(report);

  const reportStatus = candidateFacingStatus(
    status,
    candidateFacingStatusEnabled,
  );
  const reportSecondaryStatus = candidateFacingStatus(
    secondaryStatus,
    candidateFacingStatusEnabled,
  );
  const showDownloadPDFDropdown =
    !pdf &&
    report.status !== 'suspended' &&
    (report.status !== 'pending' || report.allowDownloadDocsOnPendingReport);

  return (
    <span>
      <Panel
        data-testid='information-panel'
        className='card-plain card-border'
        title={i18n.getStr(
          'components.Report.ScheduleComponent.infoPanel.reportInformation',
        )}
        statusType={statusType}
        status={onlySSN(report) ? '' : reportStatus}
        secondaryStatus={reportSecondaryStatus}
        statusLabel
      >
        <CandidateProfileSelector
          canada={canada}
          international={international}
          pdf={pdf}
          report={report}
          segmentationEnabled={
            !!(
              (report.account && report.account.segmentationEnabled) ||
              (account && account.segmentationEnabled)
            )
          }
        />

        <DrugScreeningAppointment report={report} />
        {report.status === 'pending' && getDonorPass(report.documents) && (
          <div className='float-right'>
            <M.Link
              href={getDonorPass(report.documents).downloadUri}
              target='_blank'
              rel='noopener noreferrer'
            >
              <M.Button kind='secondary'>
                <T value='buttons.downloadDownloadDonorPass' />
              </M.Button>
            </M.Link>
          </div>
        )}

        {showDownloadPDFDropdown && (
          <div className='float-right'>
            <DownloadPDFDocuments
              consentLink={report.consentLink}
              documents={report.documents}
              candidate={report.candidate}
              report={report}
            />
          </div>
        )}
      </Panel>
      {includesAppointment(report) && !pdf && (
        <Panel
          className='card-plain card-border card-secondary card-screening-information'
          title={i18n.getStr(
            'components.Report.ScheduleComponent.infoPanel.healthScreeningTitle',
          )}
        >
          <HealthScreeningInformation report={report} />
        </Panel>
      )}
    </span>
  );
};

Information.propTypes = {
  canada: PropTypes.bool,
  international: PropTypes.bool,
  pdf: PropTypes.bool,
  report: PropTypes.object,
  account: PropTypes.object,
  candidateFacingStatusEnabled: PropTypes.bool,
};

Information.defaultProps = {
  canada: false,
  international: false,
  pdf: false,
  report: {},
  account: {},
  candidateFacingStatusEnabled: false,
};

export default Information;
